export const defaultClassName = 'flex flex-1 overflow-auto scrollbar'
